import { render, staticRenderFns } from "./ShowScope.vue?vue&type=template&id=8071efba"
import script from "./ShowScope.vue?vue&type=script&lang=js"
export * from "./ShowScope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports